import React, { useState,useRef, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { useReactToPrint } from "react-to-print";

import VatUpdate from "./VatUpdate";

const VatList = () => {
  const [vatList, setVatList] = useState([]);
  const [vatId, setVatId] = useState(null);
  const [change, setchange] = useState(false);
  const [viewMore, setViewMore] = useState(true)

  const printRef=useRef(null)


  const print = useReactToPrint ({
    content: () => printRef.current,
  });

  useEffect(() => {
    api
      .get("/services/vat-entry/")
      .then((response) => {
        // console.log(response.data)
        setVatList(response.data);
      })
      .catch((error) => {
        alert("something went wrong");
      });
  }, [change]);

  const handleDelete = (id) => {
    api
      .delete(`/services/vat-entry/${id}/`)
      .then((response) => {
        toast.success("Deleted Successfully");
        setVatList(vatList.filter((item) => item.id !== id));
      })
      .catch((error) => {
        toast.error("Unable to Delete");
      });
  };

  const handleSearch = (e) => {

    api.get(`services/vat-entry/?search=${e.target.value}`)
    .then(response=> {
      // console.log(response.data)
      setVatList(response.data)
    }).catch(error=> {
      console.log(error)
    })

}

  return (
    <div className="px-10">
      <div className="text-center text-primary-red text-2xl font-bold my-3">
        Vat Entry List
      </div>
      <input
        placeholder="Search Vat Entry Month "
        type="search"
        onChange={(e)=> handleSearch(e)}
        className="my-3 rounded-lg border border-black p-3"
      />

      <table ref={printRef} className="border-primary-blue overflow-x-auto min-w-full border text-center">
        <thead className="font-Bree bg-primary-red text-lg font-bold">
          <tr className="">
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              SN.
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Vat Entry of The Month
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Entry End Date
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Office Name
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Staff Name
            </th>

            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Action
            </th>
            <th
              scope="col"
              className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody className="font-Acme">
          {vatList.length < 1 && "No Data "}
          {vatList?.slice(0, `${viewMore ? 10 : vatList.length}`)?.map((item, i) => {
            return (
              <tr className="border-primary-blue border-2 bg-white" key={i}>
                <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                  {i + 1}
                </td>
                <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                  {/* 2078/1/1 */}
                  {item.start_date}
                </td>
                <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                  {item.end_date}
                </td>
                <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                  {item.company_name}
                </td>
                <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                  Anish
                </td>

                <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                  <button
                    className="bg-primary-blue hover:bg-red-500 rounded-full p-1 mr-1 px-2 text-white"
                    data-bs-toggle="modal"
                    data-bs-target="#VatModal"
                    onClick={() => {
                      setVatId(item.id);
                    }}
                  >
                    Update
                  </button>

                  <VatUpdate
                    VatId={vatId}
                    setchange={setchange}
                    change={change}
                  />

                  <button
                    className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </button>
                </td>
                <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                  {item.status}
                </td>
              </tr>
            );
          })}

          {/* <tr className="border-primary-blue border-2 bg-white">
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              1
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              2078/1/1
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              2079/1/2
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              graphic marga
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              Anish
            </td>

            <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
              <button className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white">
                View
              </button>
              <button className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white">
                Update
              </button>
              <button className="bg-primary-blue hover:bg-red-500 rounded-full p-1 px-2 text-white">
                Delete
              </button>
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              approved
            </td>
          </tr> */}
        </tbody>
      </table>

      <div  onClick={print} className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
        <button >Print</button>
      </div>
      <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
        {viewMore ? (
          <button onClick={() => setViewMore(false)}>View More</button>
        ) : (
          <button onClick={() => setViewMore(true)}>View Less</button>
        )}
      </div>
    </div>
  );
};

export default VatList;
